import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import md5 from "md5";
import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  async getPet(petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");

    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/pet/${Crypto.encrypt(petID, CryptoKey)}`;

    const rsp = await httpGet(apiUrl);

    if (rsp.code === 100000) {
      rsp.result.timeOfDeath = rsp.result.timeOfDeath || "";
    }

    return rsp;
  }

  getPetListByUserID(userID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/getList/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpGet(apiUrl);
  }

  getBulkPet(petIDs) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/bulk/read`;
    return httpPost(apiUrl, { ids: petIDs });
  }

  createPet(petData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet`;
    return httpPost(apiUrl, petData);
  }

  modifyPet(petID, petData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}`;
    return httpPut(apiUrl, petData);
  }

  modifyPetParams(petID, petData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/updateParams/${Crypto.encrypt(petID, CryptoKey)}`;
    return httpPut(apiUrl, petData);
  }

  modifyPetBirth(petID, petBirth) {
    console.log("update birth");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}`;
    return httpPut(apiUrl, { birth: petBirth });
  }

  modifyPetTimeOfDeath(petID, petTimeOfDeath) {
    console.log("update timeOfDeath");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}`;
    return httpPut(apiUrl, { timeOfDeath: petTimeOfDeath });
  }

  deletePet(petID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}`;
    return httpDelete(apiUrl);
  }

  getPetList(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/getList`;
    return httpPost(apiUrl, options);
  }

  searchPet(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/search`;
    return httpPost(apiUrl, options);
  }

  simpleSearchPet(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/simpleSearch`;
    return httpPost(apiUrl, options);
  }

  getPetDetailByParams(params) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/getDetail`;
    return httpPost(apiUrl, params);
  }

  getPetPage(currentPage) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/getListPage`;
    return httpPost(apiUrl, currentPage);
  }

  getListPageWithQuery(query = {}) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/getListPageWithQuery`;

    return httpPost(apiUrl, query);
  }

  addPetWeight(petID, salt, weight, dateTime, source = "") {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}/weight`;
    return httpPost(apiUrl, { salt, weight, dateTime, source });
  }

  updatePetWeight(petID, weightID, weight, dateTime, source = "") {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}/weight/${Crypto.encrypt(
      weightID,
      CryptoKey
    )}`;
    return httpPut(apiUrl, { weight, dateTime, source });
  }

  deletePetWeight(petID, weightIDArray) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}/weightDelete`;
    return httpPost(apiUrl, { weightIDArray });
  }

  touchPet(petID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}/touch`;
    return httpPost(apiUrl);
  }

  touchUserAndPet(petID, onlyUser) {
    // console.log("V2.touchUserAndPet");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}/touchUserAndPet`;
    return httpPost(apiUrl, { onlyUser });
  }

  updatePetIDCounter(petID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}/updatePetIDCounter`;
    return httpPost(apiUrl);
  }

  uploadPetAvatar(petID, avatar) {
    let photoData = new FormData();
    photoData.append("photo", avatar);

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(petID, CryptoKey)}/avatar`;
    return httpUploadFormData(apiUrl, photoData);
  }

  uploadBreedAvatar(breedID, avatar) {
    let photoData = new FormData();
    photoData.append("photo", avatar);

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/breed/${md5(breedID)}/avatar`;
    return httpUploadFormData(apiUrl, photoData);
  }

  renamePetID(oldID, newID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(oldID, CryptoKey)}/rename/ID`;
    return httpPut(apiUrl, { newID });
  }

  combinePet(transferID, mainID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/pet/${Crypto.encrypt(transferID, CryptoKey)}/combine/ID`;
    return httpPut(apiUrl, { mainID });
  }
}
